"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _querystring = _interopRequireDefault(require("querystring"));
var _FormWrap = _interopRequireDefault(require("./FormWrap"));
var _Input = _interopRequireDefault(require("./Input"));
var _TelephoneInput = _interopRequireDefault(require("./TelephoneInput"));
var _CheckBox = _interopRequireDefault(require("./CheckBox"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _Alert = _interopRequireDefault(require("../Alert/Alert"));
var _pricing = require("../../helpers/pricing");
var _envConstants = require("../../env-constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // import fetch from 'isomorphic-unfetch';
var RefundRequestForm = function RefundRequestForm(_ref) {
  var bookingId = _ref.bookingId,
    profileId = _ref.profileId,
    guestName = _ref.guestName,
    creditHeld = _ref.creditHeld,
    userEmail = _ref.userEmail,
    currency = _ref.currency,
    endpoint = _ref.endpoint;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    submitting = _useState2[0],
    setSubmitting = _useState2[1];
  var _useState3 = (0, _react.useState)({
      errorMessage: 'Something went wrong, please try again later',
      successMessage: 'Thank you for your request.',
      notification: '',
      showNotification: false
    }),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    notification = _useState4[0],
    setNotification = _useState4[1];
  var _useState5 = (0, _react.useState)({
      emailAddress: userEmail,
      interest: false
    }),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    formData = _useState6[0],
    setFormData = _useState6[1];
  var onChange = function onChange(e) {
    return setFormData(_objectSpread(_objectSpread({}, formData), {}, (0, _defineProperty2["default"])({}, e.target.name, e.target.value)));
  };
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    setSubmitting(true);
    var emailAddress = formData.emailAddress,
      phoneNumber = formData.phoneNumber;
    var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (!filter.test(emailAddress)) {
      setNotification(_objectSpread(_objectSpread({}, notification), {}, {
        notification: 'error',
        errorMessage: 'Please check your email address is correct.',
        showNotification: true
      }));
      setSubmitting(false);
    } else if (!phoneNumber) {
      setNotification(_objectSpread(_objectSpread({}, notification), {}, {
        notification: 'error',
        errorMessage: 'Please fill in telephone number.',
        showNotification: true
      }));
      setSubmitting(false);
    } else {
      submitForm();
    }
  };
  var submitForm = function submitForm() {
    var emailAddress = formData.emailAddress,
      phoneNumber = formData.phoneNumber,
      interest = formData.interest;
    var query = {
      booking_id: bookingId,
      profile_id: profileId,
      guest_name: guestName,
      credit_held: (0, _pricing.formatCurrency)(creditHeld / 100, currency),
      email_address: emailAddress.trim(),
      phone_number: phoneNumber,
      interest: interest ? 'yes' : 'no',
      product: _envConstants.ENV.SITE
    };

    // https://medium.com/@dmccoy/how-to-submit-an-html-form-to-google-sheets-without-google-forms-b833952cc175
    // I also added a check for duplicate emails and if the first character is '='

    fetch("".concat(endpoint, "?").concat(_querystring["default"].stringify(query)), {
      method: 'GET'
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      if (response && response.result === 'success') {
        setNotification(_objectSpread(_objectSpread({}, notification), {}, {
          notification: 'success',
          showNotification: true
        }));
        sendConfirmationEmail();
      } else {
        setNotification(_objectSpread(_objectSpread({}, notification), {}, {
          notification: 'error',
          errorMessage: 'Something went wrong, please try again later',
          showNotification: true
        }));
      }
      setSubmitting(false);
    });
  };
  var sendConfirmationEmail = function sendConfirmationEmail() {
    var emailAddress = formData.emailAddress;
    var infoEmail = _envConstants.ENV.SITE === 'tsw' ? 'info@theskiweek.com' : 'info@theyachtweek.com';
    fetch('/api/booking/send-email', {
      method: 'POST',
      body: JSON.stringify({
        to: emailAddress.trim(),
        subject: 'Form Received - Refund Credit Note Exchange',
        body: "\n          <p>Thank you for completing the form to submit your decision to exchange your Refund Credit Note for a cash refund.</p>\n          <p>We will be in contact to confirm when your refund has been processed or if there is any additional information required to process this for you.\n          As we are a small team working through a large volume of requests, please allow up to 28 days for processing.</p>\n          <p>Any questions in the meantime, do not hesitate to reach out to us at <a href=\"mailto:".concat(infoEmail, "\">").concat(infoEmail, "</a></p>\n        ")
      })
    })["catch"](function (err) {
      console.error(err);
      setNotification(_objectSpread(_objectSpread({}, notification), {}, {
        notification: 'error',
        errorMessage: err,
        showNotification: true
      }));
    });
  };
  if (notification.notification === 'success') {
    return /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
      className: "margin-y-md",
      show: !!notification.showNotification,
      text: notification.successMessage,
      onClose: function onClose() {
        return setNotification(_objectSpread(_objectSpread({}, notification), {}, {
          showNotification: false
        }));
      },
      type: notification.notification
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_FormWrap["default"], {
    className: "margin-top-md",
    onSubmit: handleSubmit,
    loading: submitting
  }, /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    id: "guestName",
    label: "Name",
    type: "text",
    name: "guestName",
    value: guestName,
    disabled: true
  }), /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    id: "creditHeld",
    label: "Credit",
    type: "text",
    name: "creditHeld",
    value: (0, _pricing.formatCurrency)(creditHeld / 100, currency),
    disabled: true
  }), /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    id: "emailAddress",
    label: "Email address",
    type: "email",
    name: "emailAddress",
    value: formData.emailAddress,
    onChange: onChange,
    required: true
  }), /*#__PURE__*/_react["default"].createElement(_TelephoneInput["default"], {
    id: "phoneNumber",
    label: "Telephone number",
    name: "phoneNumber",
    onChange: function onChange(number) {
      return setFormData(_objectSpread(_objectSpread({}, formData), {}, {
        phoneNumber: number
      }));
    },
    required: true
  }), /*#__PURE__*/_react["default"].createElement(_CheckBox["default"], {
    id: "interest",
    label: "I'd love to hear about future ".concat(_envConstants.ENV.SITE === 'tyw' ? 'Yacht Week' : 'The Ski Week', " events and how I can receive an additional 10% value on my current credit for any future bookings."),
    name: "interest",
    onChange: function onChange() {
      return setFormData(_objectSpread(_objectSpread({}, formData), {}, {
        interest: !formData.interest
      }));
    },
    checked: formData.interest
  }), /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    className: "margin-y-md",
    show: !!notification.showNotification,
    text: notification.errorMessage,
    onClose: function onClose() {
      return setNotification(_objectSpread(_objectSpread({}, notification), {}, {
        showNotification: false
      }));
    },
    type: notification.notification
  }), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "margin-top-md",
    type: "submit",
    text: submitting ? 'Submitting...' : 'Submit',
    disabled: submitting,
    fullWidth: true
  }));
};
RefundRequestForm.propTypes = {
  bookingId: _propTypes["default"].number.isRequired,
  profileId: _propTypes["default"].number.isRequired,
  guestName: _propTypes["default"].string.isRequired,
  creditHeld: _propTypes["default"].string.isRequired,
  userEmail: _propTypes["default"].string.isRequired,
  currency: _propTypes["default"].string.isRequired,
  endpoint: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = RefundRequestForm;